import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import PlayerAvatar from '../ui/PlayerAvatar';
import TeamCrest from '../ui/TeamCrest';
import tokens from '../../theme/tokens';

// Card de jogador do torneio no estilo "figurinha": foto, time, país, ranking e pote.
const PlayerCard = ({ playerName, tower, playerImage, ranking, pote, teamName, paisImage, shirtNumber }) => {
  const showFlag = paisImage && paisImage !== '/bandeira_BR.png' && paisImage !== '/bandeira_undefined.png';

  return (
    <Box
      sx={{
        position: 'relative',
        width: 200,
        flexShrink: 0,
        borderRadius: 4,
        overflow: 'hidden',
        color: '#fff',
        background: `linear-gradient(160deg, ${tokens.color.inkSoft} 0%, ${tokens.color.ink} 60%, ${tokens.color.brandDark} 140%)`,
        boxShadow: tokens.shadow.md,
        transition: 'transform .2s ease',
        '&:hover': { transform: 'translateY(-4px)' },
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ p: 1.5 }}>
        <Box>
          <Typography sx={{ fontFamily: tokens.font.display, fontSize: '2rem', lineHeight: 1, fontWeight: 700 }}>
            {pote ?? '-'}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.7, textTransform: 'uppercase' }}>Pote</Typography>
        </Box>
        <Stack alignItems="flex-end" spacing={0.5}>
          {teamName && <TeamCrest name={teamName} size={32} />}
          {showFlag && <Box component="img" src={paisImage} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} sx={{ width: 28, height: 18, objectFit: 'cover', borderRadius: 0.5 }} />}
        </Stack>
      </Stack>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: -1 }}>
        <PlayerAvatar src={playerImage} name={playerName} size={112} ring />
      </Box>

      <Box sx={{ textAlign: 'center', px: 1.5, pt: 1.5, pb: 2 }}>
        <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '1.25rem', textTransform: 'uppercase', lineHeight: 1.1 }} noWrap title={playerName}>
          {playerName}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.7, textTransform: 'uppercase' }}>
          {tower ? `Torre ${tower}` : ' '}
        </Typography>
        <Stack direction="row" justifyContent="center" spacing={2} sx={{ mt: 1.5, pt: 1.5, borderTop: '1px solid rgba(255,255,255,0.12)' }}>
          <Box>
            <Typography fontWeight={700}>{ranking ?? '-'}º</Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>Ranking</Typography>
          </Box>
          {shirtNumber !== undefined && (
            <Box>
              <Typography fontWeight={700}>{shirtNumber}</Typography>
              <Typography variant="caption" sx={{ opacity: 0.7 }}>Camisa</Typography>
            </Box>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default PlayerCard;
